<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR COMPETÊNCIA/HABILIDADE' : 'NOVA COMPETÊNCIA/HABILIDADE'" titleIcon="fas fa-edit">

            <div v-if="modoEdicao && !carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="Competências, conteúdos, habilidades, capacidades e atitudes. Vincule ao componente curricular da etapa da matriz e, quando for um desdobramento, indique o item pai."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Tipo" prop="tipo" :rules="[$requiredChange]">
                            <el-select v-model="dados.tipo" style="width: 100%;">
                                <el-option v-for="t in tipos" :key="t.valor" :label="t.label" :value="t.valor"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Código (BNCC)">
                            <el-input v-model="dados.codigo" maxlength="40" placeholder="Ex.: EF01MA01"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Ordem">
                            <el-input-number v-model="dados.ordem" :min="0" :step="1" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Grupo de Conteúdo">
                            <el-select v-model="dados.grupo_conteudo_id" filterable clearable placeholder="(nenhum)" style="width: 100%;">
                                <el-option v-for="g in gruposConteudo" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição" prop="descricao" :rules="[$requiredBlur]">
                            <el-input type="textarea" :rows="3" v-model="dados.descricao" placeholder="Descrição da competência, conteúdo, habilidade, capacidade ou atitude"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <label style="font-weight: bold;">Vínculo com a matriz curricular</label>
                <div style="color: #909399; font-size: 12px; margin-bottom: 8px;">
                    Opcional. Selecione a matriz e a etapa para escolher o componente curricular.
                </div>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Matriz Curricular">
                            <el-select v-model="matrizId" filterable clearable placeholder="(nenhuma)" style="width: 100%;" @change="onTrocarMatriz">
                                <el-option v-for="m in matrizes" :key="m.id" :label="m.nome" :value="m.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Etapa">
                            <el-select v-model="etapaId" filterable clearable placeholder="(nenhuma)" style="width: 100%;" :disabled="!matrizId" @change="onTrocarEtapa">
                                <el-option v-for="e in etapas" :key="e.id" :label="e.nome" :value="e.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Componente Curricular">
                            <el-select v-model="dados.matriz_etapa_componente_id" filterable clearable placeholder="(nenhum)" style="width: 100%;" :disabled="!etapaId">
                                <el-option v-for="c in componentes" :key="c.id" :label="nomeComponente(c)" :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Item pai (quando este registro for um desdobramento)">
                            <el-select v-model="dados.objetivo_pai_id" filterable clearable placeholder="(nenhum — item raiz)" style="width: 100%;">
                                <el-option v-for="o in possiveisPais" :key="o.id" :label="rotuloPai(o)" :value="o.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/objetivo-aprendizagem">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        dados: {
            tipo: '', codigo: '', descricao: '', ordem: 0, situacao: true,
            grupo_conteudo_id: null, matriz_etapa_componente_id: null, objetivo_pai_id: null
        },
        matrizId: null,
        etapaId: null,
        matrizes: [],
        etapas: [],
        componentes: [],
        gruposConteudo: [],
        objetivos: [],
        modoEdicao: false,
        carregado: false,
        tipos: [
            { valor: 'competencia', label: 'Competência' },
            { valor: 'conteudo', label: 'Conteúdo' },
            { valor: 'habilidade', label: 'Habilidade' },
            { valor: 'capacidade', label: 'Capacidade' },
            { valor: 'atitude', label: 'Atitude' }
        ]
    }),
    computed: {
        /** Exclui apenas o próprio registro da lista; ciclos são validados no backend. */
        possiveisPais () {
            const id = this.$route.params.id ? parseInt(this.$route.params.id) : null
            return this.objetivos.filter(o => o.id !== id)
        }
    },
    mounted () {
        this.carregarAuxiliares()
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        rotuloTipo (valor) {
            const t = this.tipos.find(x => x.valor === valor)
            return t ? t.label : valor
        },
        rotuloPai (o) {
            return `[${this.rotuloTipo(o.tipo)}] ${o.descricao}`
        },
        nomeComponente (c) {
            if (c.disciplina) return c.disciplina.nome_area
            if (c.eixo_tematico) return c.eixo_tematico.nome
            return '#' + c.id
        },
        carregarAuxiliares () {
            const cfg = this.$store.getters.getHeaderAuth
            const base = this.$store.state.config.baseUrlApi

            this.$axios.get(`${base}/api/grupo-conteudo/getAll`, cfg)
                .then(r => { this.gruposConteudo = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))

            this.$axios.get(`${base}/api/matriz-curricular/getAll`, cfg)
                .then(r => { this.matrizes = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))

            this.$axios.get(`${base}/api/objetivo-aprendizagem/getAll`, cfg)
                .then(r => { this.objetivos = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        onTrocarMatriz () {
            this.etapaId = null
            this.etapas = []
            this.componentes = []
            this.dados.matriz_etapa_componente_id = null
            if (!this.matrizId) return

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/etapas/${this.matrizId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.etapas = Array.isArray(r.data) ? r.data : [] })
             .catch(e => this.$store.commit('throwException', e))
        },
        onTrocarEtapa () {
            this.componentes = []
            this.dados.matriz_etapa_componente_id = null
            if (!this.etapaId) return

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/componentes/${this.etapaId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                this.componentes = (r.data && Array.isArray(r.data.componentes)) ? r.data.componentes : []
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/objetivo-aprendizagem/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                this.dados.tipo = reg.tipo || ''
                this.dados.codigo = reg.codigo || ''
                this.dados.descricao = reg.descricao || ''
                this.dados.ordem = reg.ordem || 0
                this.dados.situacao = reg.situacao === false ? false : true
                this.dados.grupo_conteudo_id = reg.grupo_conteudo_id || null
                this.dados.matriz_etapa_componente_id = reg.matriz_etapa_componente_id || null
                this.dados.objetivo_pai_id = reg.objetivo_pai_id || null
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/objetivo-aprendizagem/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/objetivo-aprendizagem/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/objetivo-aprendizagem')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
